import defaultAttributes from '../defaultAttributes';
import type { IconNode } from '../types';

const Music3: IconNode = [
  'svg',
  defaultAttributes,
  [
    ['circle', { cx: '12', cy: '18', r: '4' }],
    ['path', { d: 'M16 18V2' }],
  ],
];

export default Music3;
